import React from 'react';
import './Incentives.scss';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';

const Incentives = (props) => {
  const location = useLocation();

  const vehicle = location?.state?.car
    ? {
        make: location.state.car.make,
        model: location.state.car.model,
        model_year: location.state.car.model_year,
        handle: location.state.car.handle,
      }
    : undefined;


  return (
    <div className="incentives-catalog-container">
      <div className="container">
        <h1 className="title-incentives">
          <FormattedMessage
            id="incentives.title"
            defaultMessage="Electric vehicle and charger incentives"
            description="Electric vehicle and charger incentives"
          />
        </h1>
        <h2 className="subtitle-incentives">
          <FormattedMessage
            id="incentives.subTitle"
            defaultMessage="You may be eligible for a range of incentives, including EV rebates, EV tax credits and various other benefits. Adjust the filters to personalize your results. Please note that all fields under 'Home and tax status' and 'Purchase information' must be completed in order to receive an estimate of the total amount you may be eligible for."
          />
        </h2>
        <zr-incentives-catalog-widget
          {...(vehicle ?? {})}
          lang={props.language.toLowerCase() ?? 'en'}
        ></zr-incentives-catalog-widget>
      </div>
    </div>
  );
};

export default Incentives;
